import styled from 'styled-components';
import checkMark from '../../assets/svg/icon-check-mark-green.svg';

export const Select = styled.select`
  -moz-appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-position-x: ${p => (p.checkMark ? '95%' : '99%')};
  background-position-y: 50%;
  background-repeat: no-repeat;
  border: none;
  padding: 12px;
  width: 100%;
`;

export const CheckMark = styled.span`
  background-image: url(${checkMark});
  background-position: center;
  background-size: 100%;
  height: 30px;
  position: absolute;
  right: 7px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
`;

export const SelectWrapper = styled.div`
  border-radius: 5px;
  border: 1px solid ${p => p.theme.color.gray};
  position: relative;
  width: 80%;
`;

export const SelectSpacing = styled.div`
  margin-bottom: 48px;
`;

export const SelectFieldTitle = styled.p`
  font-weight: bold;
  margin: 0;
`;

export const SelectFieldDescription = styled.p`
  margin: -4px 0 10px 0;
  font-size: 14px;
`;



// WEBPACK FOOTER //
// ./src/components/SelectField/styles.js